import styled from "styled-components";
import { ReactComponent as MailOutline } from "../../../assets/images/svg/mail-outline.svg";

export const PrivacyPolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 720px;
  padding: 0px 40px;
`;

export const PrivacyPolicyTitle = styled.h1`
  text-align: center;
  font-weight: 700;
  letter-spacing: -2px;
  margin-top: 20px;
  margin-bottom: 120px;
  font-size: 56px;
  line-height: 110%;

  @media screen and (max-width: 991px) {
    font-size: 48px;
  }

  @media screen and (max-width: 479px) {
    margin-bottom: 32px;
    font-size: 40px;
    line-height: 100%;
  }
`;

export const PrivacyPolicyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 88px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const UpdateText = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 170%;
`;

export const PrivacyPolicyText = styled.div`
  font-size: 18px;
  line-height: 170%;
  font-weight: 400;
`;

export const SectionTitle = styled.div`
  font-size: 24px;
  line-height: 150%;
  font-weight: 600;
`;

export const SectionSubTitle = styled.div`
  font-size: 20px;
  line-height: 150%;
  font-weight: 600;
`;
export const SectionSubTitle2 = styled.div`
  font-size: 20px;
  line-height: 150%;
  font-weight: 500;
`;
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const SubSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const ListContaniner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ListItem = styled.li`
  font-size: 18px;
  line-height: 170%;
  font-weight: 400;
  list-style-type: disc;
  position: relative;

  strong {
    font-weight: 600;
  }
`;

export const ContactEmail = styled.a`
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  display: flex;
`;

export const ContactLink = styled.span`
  color: ${(props) => props.theme.colors.black};
  font-size: 18px;
  font-weight: 700;
  line-height: 170%;
  text-decoration: none;
`;

export const MailOutlineStyled = styled(MailOutline)`
  filter: invert(1);
  height: 18px;
  width: 18px;
`;